import { useNavigate } from "react-router-dom";
import type { ReactNode } from "react";
import { Button } from "../../../../components/common/button";
import { Heading, Text } from "../../../../components/common/typography";

interface Props {
  title: string;
  viewAllRoute: string;
  children: ReactNode;
}

export function DashboardSectionCard({ title, viewAllRoute, children }: Props) {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col gap-4 rounded-2xl border border-borderDefault bg-bgWhite p-6 max-md:p-4 shadow-[0px_2px_12px_0px_rgba(190,189,217,0.2)]">
      <div className="flex items-center justify-between max-md:gap-3">
        <Heading variant="h3" tone="dark">{title}</Heading>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate(viewAllRoute)}
          className="!h-auto !p-0 hover:!text-accentGreenDark max-md:shrink-0"
        >
          <Text variant="bodySmBold" tone="inherit" inline>View all →</Text>
        </Button>
      </div>
      <div className="flex flex-col gap-3">{children}</div>
    </div>
  );
}
